export const environment = {
  production: false,
  CASHBACK_API: 'https://bff-dev-cashback.grupomadero.com.br/',
  CRYPTO_AES_KEY: 'UHktYnjDuIsdx4P/nOTYxebtBMcbobQ+QHzJv9+0D+g=',
  CRYPTO_AES_IV: 'IRb427vMGBxoRZfGjM9hCg==',
  ENABLE_DEBUG: false,
};
